import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPictureInPictureStyle0 = cosmosIconCss;

const CosmosIconPictureInPicture$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPictureInPicture extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4b7d8ee41407d31bc90e155acb5bda29534c074c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'dc4f50ba90f85c176c24251182d951343868c14c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '83d81360a7abc5c65681620e3e08ef26eb91e035', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-13Zm1.5 1h15v11h-15v-11ZM17 11h-6v4h6v-4Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPictureInPictureStyle0; }
}, [1, "cosmos-icon-picture-in-picture", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-picture-in-picture"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-picture-in-picture":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPictureInPicture$1);
            }
            break;
    } });
}

const CosmosIconPictureInPicture = CosmosIconPictureInPicture$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPictureInPicture, defineCustomElement };
